$(document).ready(function(){
if (!customElements.get('grid-product-upform')) {
  customElements.define('grid-product-upform', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }
  });
}
   if ($("body").hasClass("template-index")) {
  $('.group-list-wrap').slick({
  infinite: false,
  slidesToShow:4.2,
  rows: 3,
  arrows: true,
  dots: true,
  slidesToScroll:1,
  prevArrow: $('.if_prev'),
  nextArrow: $('.if_next'),
  appendDots: $('.if_slider_dots'),
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow:3.2
      }
    },
    {
      breakpoint: 1081,
      settings: {
        slidesToShow:2.2
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow:1.2
      }
    }
  ]
});

  setTimeout(function() {  
  
  var proinfo = document.getElementsByClassName("ig-list");
  var hei = 0;
  for(var i=0; i< proinfo.length; i++){
    var heigh = proinfo[i].offsetHeight;
    if(heigh > hei){
      hei = heigh;
    }
  }
  for(var i=0; i< proinfo.length; i++){
    proinfo[i].style.height = hei +"px";
  }
}, 2500);
   }
 if ($("body").hasClass("template-collection") || $("body").hasClass("template-product")) {
  if ($(window).innerWidth() < 1081) {
  $('.collections-page .group-list-wrap').slick({
    infinite: false,
    rows:9,
    slidesToShow:3.3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: $('.collections-page .if_prev'),
    nextArrow: $('.collections-page .if_next'),
    appendDots: $('.collections-page .if_slider_dots'),
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1
        }
      }
    ]
  });
  setTimeout(function() {  
  
  var proinfo = document.getElementsByClassName("ig-list");
  var hei = 0;
  for(var i=0; i< proinfo.length; i++){
    var heigh = proinfo[i].offsetHeight;
    if(heigh > hei){
      hei = heigh;
    }
  }
  for(var i=0; i< proinfo.length; i++){
    proinfo[i].style.height = hei +"px";
  }
}, 2500);
}else{
  var proinfo = document.getElementsByClassName("ig-list");
  var hei = 0;
  for(var i=0; i< proinfo.length; i++){
    var heigh = proinfo[i].offsetHeight;
    if(heigh > hei){
      hei = heigh;
    }
  }
  for(var i=0; i< proinfo.length; i++){
    proinfo[i].style.height = hei +"px";
  }
}
 }
  
});
